import { enumToOptions } from '@libs/types/src/common/enum/util';

export enum SocialServiceInformativeCodeEnum {
    I1 = 'i1',
    I2 = 'i2',
    I3 = 'i3',
    I4 = 'i4',
    I5 = 'i5',
    I6 = 'i6',
    I7 = 'i7',
    I8 = 'i8',
    I9 = 'i9',
    I10 = 'i10',
    I11 = 'i11',
    I12 = 'i12',
}

export const socialServiceInformativeCodeEnumOptions = enumToOptions(SocialServiceInformativeCodeEnum, 'serviceType.operation.informativeCode.')
